import { DoctorMSLaboratoryExaminationEntity } from "lib/graphql/megaSchema";

export const isLaboratoryExamination = (
  e: any,
): e is DoctorMSLaboratoryExaminationEntity => {
  return !("type" in e);
};
